import React, { useState, useEffect } from 'react';
import Logo from "../Img/logo.png";
import CustomNavLink from "../_Components/CustomNavLink";
import API from '../Utils/api';
import { Link } from 'react-router-dom';

async function reload() {
    await window.location.reload()
}

const GerenteTemplate = (props) => {

    const usuario = JSON.parse(localStorage.getItem("user"))

    const removeToggled = (e) => {
        window.localStorage.setItem("rotaAtual", e.target.name);
    }

    const logout = () => {
        window.localStorage.removeItem('user')
        window.localStorage.removeItem("rotaAtual");
        window.location.href = '/'
    }

    const [expanded, setExpanded] = useState(false);
    const scrollarPage = () => {
        setExpanded(!expanded)
        if (!expanded)
            window.scrollTo(500, 0);
        else {
            window.scrollTo(0, 0);
        }
    }

    const verificarUsuario = async () =>{
        try {
            const response = await API.get("/api/usuarios/verificar/"+JSON.parse(window.localStorage.getItem("user"))._id);
            if(!response.data.status)
                logout();
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        verificarUsuario();
    },[])


    return (
        <div className="wrapper">
            <div className="sidebar">
                <div className="sidebar-wrapper">
                    <div className="logo">
                        <img src={Logo} style={{ width: '10em', height: '4em' }} />
                        <div className="text-center small mt-2">
                            <div style={{ fontWeight: '500' }}>{usuario.nome.toUpperCase()} • {usuario.perfil}</div>
                        </div>
                    </div>
                    <ul className={window.location.href.includes('/gerente-criar-pedidos') ? "nav" : 'collapse'}>
                        <CustomNavLink onClick={() => window.location.href = '/imprimir-cartelas-avulsas'} className="nav-link" >
                            <i class="fas fa-angle-double-left"></i>
                            <span>SAIR DA SÉRIE</span>
                        </CustomNavLink>
                    </ul>
                    <ul className={window.location.href.includes('/gerente-criar-pedidos') ? "collapse" : 'nav'}>
                        <CustomNavLink onClick={logout} className="nav-link" >
                            <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                        </CustomNavLink>
                        <CustomNavLink to="/imprimir-cartelas-avulsas" name="imprimir-cartelas-avulsas" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i class="fas fa-ticket-alt"></i>
                            <span>Imprimir {usuario.isApp? "panfletos" : "avulsas/panfletos"}</span>
                        </CustomNavLink>
                        <CustomNavLink to="/gerente-ganhadores" name="gerente-ganhadores" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i class="fa fa-trophy" aria-hidden="true"></i>
                            <span>Ganhadores</span>
                        </CustomNavLink>
                        <CustomNavLink to="/gerente-bilhetes" name="gerente-bilhetes" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="nc-icon nc-tag-content"></i>
                            <span>Relatorio de Vendas</span>
                        </CustomNavLink>

                        {/* <CustomNavLink to="/relatorios-gerente" name="relatorios-gerente" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i class="fas fa-book-open"></i>
                            <span>Relatorios</span>
                        </CustomNavLink> */}

                        {/* <CustomNavLink to="/gerente-busca-cartela" name="gerente-busca-cartela" onClick={removeToggled.bind(this)} className="nav-link">
                            <i class="fas fa-search"></i>
                            <span>Buscar cartela</span>
                        </CustomNavLink> */}
                        {/* <CustomNavLink to="/g-criar-pedido" name="g-criar-pedido" onClick={removeToggled.bind(this)}  className="nav-link">
                        <i class="fas fa-edit"></i>
                            <span>Criar pedidos</span>
                        </CustomNavLink> */}

                        {/* <CustomNavLink to="/caixa-gerente" name="caixa-gerente" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="nc-icon nc-money-coins"></i>
                            <span>Meu Caixa</span>
                        </CustomNavLink> */}

                        {/* <CustomNavLink to="/caixas-por-cambistas" name="caixas-por-cambistas" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="nc-icon nc-money-coins"></i>
                            <span>Caixa cambista</span>
                        </CustomNavLink> */}
                        <CustomNavLink to="/gerente-gerencia-cambistas" name="gerente-gerencia-cambistas" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="nc-icon nc-bullet-list-67"></i>
                            <span>Meus cambistas</span>
                        </CustomNavLink>

                        <CustomNavLink to="/perfil-gerente" name="perfil-gerente" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i className="nc-icon nc-circle-09"></i>
                            <span>Perfil</span>
                        </CustomNavLink>
                    </ul>
                </div>
            </div>
            <div className="main-panel">
                <nav className="navbar navbar-expand-lg " color-on-scroll="500">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="#">
                            {props.label}
                        </Link>
                        <button
                            id="sideButton"
                            to="#"
                            className="navbar-toggler navbar-toggler-right"
                            type="button"
                            data-toggle="collapse"
                            aria-controls="navigation-index"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            onClick={scrollarPage}
                        >
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />

                        </button>
                        <div
                            className="collapse navbar-collapse justify-content-end"
                            id="navigation"
                        >
                            {/* <ul className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <Link className="nav-link" name="" onClick={removeToggled.bind(this)}>
                                        <span className="no-icon">Sair</span>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                </nav>
                <div className="content">
                    {props.children}
                </div>
                <footer className="footer">
                    <div className="container-fluid">
                        <nav>
                            <ul className="footer-menu">
                                <li>
                                    <Link to="#">Empresa</Link>
                                </li>
                                <li>
                                    <Link to="#">Regulamento</Link>
                                </li>
                                <li>
                                    <Link to="#">Outros projetos</Link>
                                </li>
                            </ul>
                            <p className="copyright text-center">
                                Proprietário ©
                                <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                            </p>
                        </nav>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default GerenteTemplate;